import { render, staticRenderFns } from "./LayoutSection.vue?vue&type=template&id=3b5af444&"
import script from "./LayoutSection.vue?vue&type=script&lang=ts&"
export * from "./LayoutSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ec2-user/buildAgent/work/1ca6ccddf1d626f9/resources/vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
